import restProvider from "ra-data-simple-rest";
import apiUri from "./components/ApiUri";
import { fetchUtils } from "react-admin";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig, protectedResources } from "./authConfig";

const msalInstance = new PublicClientApplication(msalConfig);

const getMsalToken = async () => {
  const accounts = msalInstance.getAllAccounts();
  
  if (!accounts || accounts.length === 0) {
    // No accounts found, redirect to login
    try {
      await msalInstance.loginRedirect({
        scopes: protectedResources.apiHello.scopes,
      });
    } catch (error) {
      console.error("Login redirect failed:", error);
      throw new Error("Authentication required");
    }
    return;
  }

  const request = {
    scopes: protectedResources.apiHello.scopes,
    account: accounts[0],
  };

  try {
    const authResult = await msalInstance.acquireTokenSilent(request);
    return authResult.accessToken;
  } catch (error) {
    // If silent token acquisition fails, try interactive method
    if (error.name === "InteractionRequiredAuthError" || error.message.includes("no_tokens_found")) {
      try {
        const authResult = await msalInstance.acquireTokenRedirect(request);
        return authResult.accessToken;
      } catch (interactiveError) {
        console.error("Interactive token acquisition failed:", interactiveError);
        throw interactiveError;
      }
    }
    console.error("Token acquisition failed:", error);
    throw error;
  }
};

const httpClient = async (url, options = {}) => {
  try {
    const token = await getMsalToken();
    
    // If token is undefined (redirect case), return early
    if (!token) {
      throw new Error("Authentication in progress");
    }
    
    if (!options.headers) {
      options.headers = new Headers({ Accept: "application/json" });
    }
    options.headers.set("Authorization", `Bearer ${token}`);
    return fetchUtils.fetchJson(url, options);
  } catch (error) {
    console.error("HTTP client error:", error);
    throw error;
  }
};

const dataProvider = restProvider(apiUri(), httpClient);

export { dataProvider, getMsalToken };
